import { Injectable } from '@angular/core';
import { User } from '../../models/user/user';
@Injectable()
export class usercommonattribute extends User {
  constructor() {
    super();
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/userservice/user.common.service.ts